<script setup lang="ts">
import { onUnmounted } from 'vue';
import { Button } from '@/components/shadcnui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/shadcnui/dialog'
import { useUserStore } from '@/store/useUserStore';
import { AlertTriangle } from 'lucide-vue-next';
import router from '@/router/router'

const UserStore = useUserStore();


onUnmounted(() => {
  router.push('/logout');
})

</script>

<template>
  <Dialog v-model:open="UserStore.isSessionDialogOpen" >
    <form>
      <DialogContent class="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            <div class="flex items-center gap-2">
            <AlertTriangle class="w-6 h-6 text-yellow-500" />
            자동로그아웃안내
            </div>
          </DialogTitle>
          <hr class="my-2 bg-" />
          <DialogDescription style="white-space: pre-line;">
            {{ '세션이 만료되어 로그아웃 되었습니다.' }}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" @click="router.push('/logout'); ">
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </form>
  </Dialog>
</template>
